<template>
    <div class="graph">
        <div :id="chartId"  style="width:100%; height:100%"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    props:{
        chartId:String,
        xData:Array,
        seriesData:Array,
        seriesData1:Array,
        seriesData2:Array,
        color:String,
        unit:String,
        type:{
            type: Object,
            default:()=> {
                return {
                    data:'昨天',
                    data2:"今天"
                }
            }
        },
    },
    data(){
        return {
            timer:null,
            myChart: null,
            option: {
                title: {
                    text:this.unit || 'kVA',
                    x: '2%',
                    y: '-2.5%',
                    textStyle:{                  //标题样式
                        fontSize: '11',
                        fontFamily:'Source Han Sans CN',
                        color:'rgba(230,243,253, 0.7)',
                    }
                },
                
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xData,
                    axisLine:{
                        lineStyle:{
                            color:'#0D94FF'
                        }
                    },
                     axisLabel: {
                        color: "rgba(230,243,253, 0.7)"  //坐标轴的文本颜色
                    },
                    axisTick:{       
                        "show":false   //去掉x轴刻度线
                    },
                },
                tooltip: {
					trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
                    backgroundColor: 'rgba(0, 10, 26, 0.8)',
                    borderRadius: 8,  
                    borderWidth: 0,
                    shadowColor:'rgba(13, 148, 255, 0.8)',
					axisPointer: {// 坐标轴指示器，坐标轴触发有效
						type: 'line', // 默认为直线，可选为：'line' | 'shadow'
					},
                    textStyle: {
                        color: '#fff'
                    },
                    // formatter:function(params){
                    //     // console.log(params);
                    //     let date = params[0].axisValue
                    //     let data = params[0].data
                    //     return `<div style="text-align:center;transform:scale(0.8);line-height:35rem;"> ${date} <br />减排量：${data}kg` 
                    // }
                },
                legend: {
                    itemWidth: 12,
                    itemHeight: 12,
                    x: "center",
                    // data: ["本月", "上月"],
                    icon: "rect",
                    left: "center", // 图例的位置
                    textStyle: {
                        color: "#ffffff",
                    },
                    data: [
                                {
                            name: this.type.data2,
                            itemStyle: {
                            color:'#ffcd8b',
                            },
                        },
                        {
                            name: this.type.data,
                            itemStyle: {
                            color: '#0D94FF',
                            },
                        }
                    ]
                },
                yAxis: {
                    type: 'value',
                    axisLine:{
                        show:false,
                        lineStyle:{
                            color:'rgba(230,243,253, 0.7)'
                        }
                    },
                    splitLine: {           //分割线
                        show: false,     //控制分割线是否显示
                        // lineStyle:{       //分割线的样式
                        //     color: ['rgba(43,70,126,1)'],
                        //     width: 2,
                        //     type: 'solid'
                        // }
                        },
                },
                series: [
                    {
                        name:this.type.data,
                        data: this.seriesData,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        // color: this.color || ['#0D94FF'] ,
                        areaStyle: {
                            color: this.color?'rgba(13,148,255,0)' :'rgba(246,189,22,0.3)'   //折线区域的背景颜色
                        },
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: this.color || '#0D94FF' //折线的颜色
                                }  ,
                                color: '#0D94FF',  //拐点颜色
                            },
                            emphasis:{
                                color:this.color || '#0D94FF',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    },
                    {
                        name:this.type.data2,
                        data: this.seriesData1,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        symbolSize:5,
                        color:'#ffcd8b',
                        areaStyle: {
                            color: 'rgba(246,189,22,0.3)'    //折线区域的背景颜色
                        },
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#ffcd8b' //折线的颜色
                                }  ,
                                color: '#ffcd8b',  //拐点颜色
                            },
                            emphasis:{
                                color:'#ffcd8b',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    },
                    {
                        data: this.seriesData2,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        // symbolSize:8,
                        // color:['#5ad8ce'],
                        // areaStyle: {
                        //     color: 'rgba(13,148,255,0.3)'    //折线区域的背景颜色
                        // },
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#5ad8ce' //折线的颜色
                                }  ,
                                color: '#5ad8ce',  //拐点颜色
                            },
                            emphasis:{
                                color:'#5ad8ce',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    },
                ],
                grid: {
                    left: "3%",
                    right: "5%",
                    bottom: "2%",
                    top: "13%",
                    containLabel: true,
                },
            },
        }
    },
    mounted(){
        this.tab()
        // 3.监听屏幕大小变化
        window.addEventListener('resize',this.chartResize)
        // 4.监听更新事件
        window.addEventListener('beforeunload', this.clearChart);
        


    },
    methods:{
        clearChart(){
            // 手动触发 destroy 相关的生命周期，
            this.$destroy();
        },
        chartResize(){
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                this.myChart.resize();
            },500)
        },
        initChart(){
            this.myChart = echarts.getInstanceByDom(document.getElementById(this.chartId));
            if(this.myChart == null){
                this.myChart = echarts.init(document.getElementById(this.chartId));
            }
            this.option && this.myChart.setOption(this.option);
        },
        tab(){
            if(this.seriesData && this.seriesData1 && !this.seriesData2){
                this.$set(this.option,'legend',{
                        itemWidth: 12,
                        itemHeight: 12,
                        x: "center",
                        // data: ["本月", "上月"],
                        icon: "rect",
                        left: "center", // 图例的位置
                        textStyle: {
                            color: "#ffffff",
                        },
                        data: [
                                    {
                                name: this.type.data2,
                                itemStyle: {
                                color:'#ffcd8b',
                                },
                            },
                            {
                                name: this.type.data,
                                itemStyle: {
                                color: '#0D94FF',
                                },
                            }
                        ]
                    })
                    this.$set(this.option.xAxis,'data',this.xData)
                this.option.series = [
                    {
                        name:this.type.data,
                        data: this.seriesData,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        areaStyle :{
                            color: 'rgba(18,144,255,0.3)'   //折线区域的背景颜色
                        },
                        itemStyle :{
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#1290ff' //折线的颜色
                                }  ,
                                color: '#1290ff',  //拐点颜色
                            },
                            emphasis:{
                                color:'#1290ff',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                        }
                    },
                    {
                        name:this.type.data2,
                        data: this.seriesData1,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        itemStyle:{
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#f6bd16' //折线的颜色
                                }  ,
                                color: '#f6bd16',  //拐点颜色
                            },
                            emphasis:{
                                color:'#f6bd16',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                        },
                        areaStyle :{
                            color: 'rgba(246,189,22,0.3)'   //折线区域的背景颜色
                        }
                    },
                    {
                        data: this.seriesData2,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#5ad8ce' //折线的颜色
                                }  ,
                                color: '#5ad8ce',  //拐点颜色
                            },
                            emphasis:{
                                color:'#5ad8ce',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    }
                ]
            }else{
                // this.$set(this.option,'legend',{
                //         textStyle: {
                //             color: ['rgba(255, 255, 255, 0)']          // 图例文字颜色
                //         },
                //         // x: 'right',
                //         data:[
                //             {icon:'rect', name:'A相'},
                //             {icon:'rect', name:'B相'},
                //             {icon:'rect', name:'C相'},
                //         ]
                //     })
                this.option.series = [
                    {
                        name:'A相',
                        data: this.seriesData,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        areaStyle: {
                            color: this.color?'rgba(13,148,255,0)' :'rgba(13,148,255,0.3)'   //折线区域的背景颜色
                        },
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: this.color || '#0D94FF' //折线的颜色
                                }  ,
                                color: '#0D94FF',  //拐点颜色
                            },
                            emphasis:{
                                color:this.color || '#0D94FF',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                        },
                    },
                    {
                        name:'B相',
                        data: this.seriesData1,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#ffcd8b' //折线的颜色
                                }  ,
                                color: '#ffcd8b',  //拐点颜色
                            },
                            emphasis:{
                                color:'#ffcd8b',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    },
                    {
                        name:'C相',
                        data: this.seriesData2,
                        type: 'line',
                        symbol: 'circle',
                        smooth:true,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                lineStyle: {        // 系列级个性化折线样式  
                                    width: 2,  
                                    type: 'solid',  
                                    color: '#5ad8ce' //折线的颜色
                                }  ,
                                color: '#5ad8ce',  //拐点颜色
                            },
                            emphasis:{
                                color:'#5ad8ce',
                                borderWidth:2,
                                borderColor:'#fff',
                                shadowColor:'#00FFFF',
                                shadowBlur:10
                            },
                            
                        },
                    }
                ]
            }
            this.initChart()
        }
    },
    watch:{
        seriesData(val){
            console.log(val);

            this.option.series[0].data = val
            this.myChart.clear()
            this.myChart = null; 
            this.tab()

        },
        seriesData1(val){
            console.log(val);
            this.option.series[1].data = val
            this.myChart.clear()
            this.myChart = null; 
            this.tab()

        },
        seriesData2(val){
            console.log(val);
            this.option.series[2].data = val
            this.myChart.clear()
            this.myChart = null; 
            this.tab()

        },
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!this.myChart) return 
        this.myChart.clear()
        this.myChart = null;  // 5. 解除引用，释放内存
    }
}
</script>

<style lang="less" scoped>
.graph{
    width: 100%;
    height: 100%;
}
</style>